<div class="items-summary-wrapper">

	<div class="items-summary-close"><div class="_inner" (mousedown)="cancel()"><mat-icon>close</mat-icon></div></div>

	<div class="items-summary-content" style="max-height: calc(100vh - 210px)" [class.highlight-validations]="highlightValidationIssues">
        @for (offer of basket; track offer) {
            <ng-container *ngTemplateOutlet="summaryOffer; context: {offer:offer}"></ng-container>
        }
	</div>
	<div class="items-summary-bottom">
		<button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (mousedown)="addItems()" [disabled]="this.highlightValidationIssues">
			<div class="_inner">
				<span>{{"TD.add-items" | translate}}</span>
				<b>{{(grandTotal) | lcurrency}}</b>
				<div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
			</div>
		</button>
	</div>
</div>

<ng-template #summaryOffer let-offer="offer">
    <div class="basket-row" [class.validation-issues]="offer.hasValidationIssues">
        <div class="_header d-flex align-items-center">
            <div class="_title">{{offer.name}}</div>
            <div class="_actions">
                @if (offer._enableEdit) {
                    <button type="button" (mousedown)="editOffer(offer)" [disabled]="offer.isLoyaltyOffer">
                        <mat-icon svgIcon="edit"></mat-icon>
                    </button>
                }
                <button type="button" (mousedown)="deleteOffer(offer, false)" [class._inactive]="offer.quantity == 1">
                    <mat-icon [svgIcon]="offer.quantity == 1 ? 'trash' : 'minus'"></mat-icon>
                </button>
                <div class="_counter text-highlight">
                    {{offer.quantity}}
                </div>
                <button type="button" (mousedown)="duplicateOffer(offer)" [disabled]="offer.isLoyaltyOffer">
                    <mat-icon svgIcon="plus"></mat-icon>
                </button>
            </div>
        </div>
        <div class="_summary">
            <div class="_summary-row" *ngIf="offer._item && offer._item.summary"><div>{{offer._item.summary.text}}</div></div>
            <ng-container *ngIf="offer.selectionSummary?.length">
                <div class="_summary-row" *ngFor="let group of offer.selectionSummary | filterBy:{_visible:true}">
                    <b>{{group.name}}:</b>
                    <div *ngFor="let item of group.items">
                        <div>
                            <span *ngIf="item.count > 1">{{item.count}}*</span>
                            {{item.name || 'missing'}}
                            <span class="inline m-near-xs" *ngIf="item._item.total > 0">+{{item._item.total | lcurrency}}</span>
                        </div>
                        <small class="block mb-1" *ngIf="item.$wasEdit && item._item.summary">{{item._item.summary.text}}</small>
                    </div>
                </div>
            </ng-container>
            <div class="_summary-row" *ngIf="offer.offerRemrks">
                <i>*{{offer.offerRemrks}}</i>
            </div>
        </div>
        <div class="_price text-highlight">
            {{offer.quantity * offer.total | lcurrency}}
        </div>
    </div>


</ng-template>
